import { Avatar, Box, Container, Grid2 as Grid, Icon, Paper, Stack, Typography } from "@mui/material"
import { slickSettings } from "../../../../../utils/helper"
import Images from "../../../../../assets/js/Images"
import Icons from "../../../../../assets/js/Icons"
import Slider from "react-slick"
import { useRef } from "react"

const questionnaireReviews = [
  {
    name: "Olivia Martin",
    role: "Matched with Licensed Counselor",
    avatarColor: "#4f46e5",
    rating: 5,
    content: "The questionnaire asked all the right questions about my goals, preferences, and background. I was matched with a counselor who felt like the perfect fit from day one.",
  },
  {
    name: "Brandon Cole",
    role: "Matched with Wellness Coach",
    avatarColor: "#059669",
    rating: 5,
    content: "I was overwhelmed trying to sift through hundreds of therapists online. InnerPal's smart questionnaire narrowed it down to the exact specialists who suited my schedule and needs.",
  },
  {
    name: "Fatima Zahra",
    role: "Matched with Naturopathy & Mindfulness Guide",
    avatarColor: "#d97706",
    rating: 5,
    content: "The questionnaire took less than 5 minutes, and connected me with an incredible naturopathy and meditation practitioner. The whole process was reassuring and effortless.",
  },
]

function Testimonials() {
  const setting = {
    ...slickSettings,
    speed: 800,
    autoplay: true,
    slidesToShow: 2,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  }
  const slickRef = useRef(null)

  return (
    <Box
      component="section"
      sx={{ pb: { xs: 5, lg: 10 }, pt: 6 }}
    >
      <Box
        sx={{
          mx: "auto",
          display: "flex",
          maxWidth: "900px",
          textAlign: "center",
          alignItems: "center",
          gap: { xs: 1, lg: 3 },
          flexDirection: "column",
        }}
      >
        <Typography
          component="h6"
          color="#7a8a9e"
          variant="sectionLead"
        >Testimonials
        </Typography>
        <Typography
          color="other.color1"
          variant="displayLarge"
        >What Our Members Say
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundSize: "cover",
          backgroundImage: `url(${Images?.specialist})`
        }}
      >
        <Container
          maxWidth={false}
          fixed
          sx={{
            py: 4,
            ".slick-track": {
              display: "flex !important",
            },
            ".slick-slide": {
              height: "inherit !important",
              display: "flex !important",
              "> div": {
                width: "100%",
                display: "flex",
                height: "100%",
              },
            },
          }}
        >
          <Slider {...setting} ref={slickRef}>
            {questionnaireReviews.map((item, i) => (
              <Box key={i} sx={{ width: "100%", height: "100%", display: "flex" }}>
                <Box sx={{ px: 3, py: 1, width: "100%", height: "100%", display: "flex" }}>
                  <Paper sx={{
                    p: "25px",
                    borderRadius: 2,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0px 0px 20px 0px #00000018"
                  }}>
                    <Box
                      sx={{
                        gap: 2,
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Avatar
                        sx={{
                          width: { xs: "45px", lg: "60px" },
                          height: { xs: "45px", lg: "60px" },
                          bgcolor: item.avatarColor,
                          fontWeight: 700,
                          fontSize: { xs: "16px", lg: "20px" },
                        }}
                      >
                        {item.name.split(" ").map(n => n[0]).join("")}
                      </Avatar>
                      <Box>
                        <Typography
                          sx={{
                            lineHeight: "1.2",
                            fontWeight: "700",
                            color: "other.color1",
                            fontSize: { xs: "18px", lg: "20px" },
                          }}
                        >
                          {item.name}
                        </Typography>
                        <Typography
                          sx={{
                            mt: 0.5,
                            color: "#6c757d",
                            fontWeight: "500",
                            fontSize: "14px"
                          }}
                        >
                          {item.role}
                        </Typography>
                      </Box>
                    </Box>
                    <Grid container spacing={2} mt="10px" sx={{ flexGrow: 1 }}>
                      <Grid size="auto" order={{ xs: 2, md: 1, lg: 2, xl: 1 }}>
                        <Icon sx={{ fontSize: "60px", color: "secondary.main" }}>
                          <Icons.Quote1 />
                        </Icon>
                      </Grid>
                      <Grid size="grow" order={{ xs: 1, md: 2, lg: 1, xl: 2 }} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        <Typography
                          sx={{
                            p: "10px",
                            opacity: "0.85",
                            color: "#556370",
                            fontWeight: "400",
                            lineHeight: "26px",
                            fontSize: "15px",
                            transition: "all 300ms ease",
                            ":hover": {
                              opacity: "1",
                              color: "#223645",
                            }
                          }}
                        >
                          "{item.content}"
                        </Typography>
                        <Stack
                          mt={1.5}
                          spacing={0.5}
                          direction="row"
                        >
                          {new Array(5).fill().map((_, starIndex) => (
                            <Icon
                              key={starIndex}
                              sx={{
                                fontSize: "20px",
                                color: starIndex < item.rating ? "#e5b216" : "#d6d6d6"
                              }}
                            >
                              <Icons.Star />
                            </Icon>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>
              </Box>
            ))}
          </Slider>
        </Container>
      </Box>
    </Box>
  )
}

export default Testimonials